import { Operator } from "../../services/operator";
import router from "./../../router";

export const state = {
  alertError: false,
  errorMessage: null
};

export const getters = {
  redirectPathName(state) {
    if (state.redirectFrom) return state.redirectFrom;

    return "/mapa";
  },

  getterAlertError(state) {
    return state.alertError;
  }
};

export const mutations = {
  SET_ALERT_ERROR(state, error) {
    state.alertError = error;
  },
  SET_ERROR_MESSAGE(state, errorMessage) {
    return (state.errorMessage = errorMessage);
  },
  SET_REDIRECT_FROM(state, redirectFrom) {
    state.redirectFrom = redirectFrom;
  }
};

export const actions = {
  login({ commit, dispatch, getters }, payload) {
    commit("SET_REDIRECT_FROM", payload.redirectFrom);
    return Operator.login(payload)
      .then(response => {
        commit("auth/SET_LOGGED_IN", true, { root: true });
        dispatch("user/showOperator", response.data.id, { root: true }).then(
          () => {
            router.push({ path: getters.redirectPathName });
          }
        );
        return response;
      })
      .catch(error => {
        if (error.response.status === 401) {
          commit("SET_ALERT_ERROR", !state.alertError);
        }
      });
  },

  logoutOperator({ commit, dispatch }) {
    return Operator.logout()
      .then(
        () => (
          commit("auth/SET_LOGGED_IN", false, { root: true }),
          sessionStorage.clear(),
          sessionStorage.setItem("vuex", ""),
          router.push({ name: "Login" })
        )
      )
      .catch(error => error);
  },

  register({ commit }, payload) {
    return Operator.register(payload)
      .then(response => {
        return response;
      })
      .catch(error => {
        commit("SET_ERROR_MESSAGE", error);
      });
  },

  forgotPassword({ commit, state }, payload) {
    return Operator.forgotPassword(payload).catch(error => {
      if (error.response.status == 404) {
        commit("SET_ALERT_ERROR", !state.alertError);
      }
      return error;
    });
  },

  updatePassword({ commit, dispatch, getters }, payload) {
    return Operator.updatePassword(payload)
      .then(response => {
        commit("auth/SET_LOGGED_IN", true);
        dispatch("user/showUser", response.data.data.id, { root: true }).then(
          () => {
            router.push({ path: getters.redirectPathName });
          }
        );
        return response;
      })
      .catch(error => error);
  },

  fetchUsersLocation({}) {
    return Operator.fetchUsersLocation();
  },

  fetchUserInstitutions({}, payload) {
    return Operator.fetchUserInstitutions(payload);
  },

  fetchAlerts({}) {
    return Operator.fetchAlerts();
  },

  showAlert({}, payload) {
    return Operator.showAlert(payload);
  },

  updateUserStatus({}, payload) {
    return Operator.updateUserStatus(payload);
  },

  fetchUserInstitutionSymptoms({}, payload) {
    return Operator.fetchUserInstitutionSymptoms(payload);
  }
};
